import { Link } from "react-router-dom";
import { GithubMark, XMark } from "../BrandIcons";
import type { X402LinkedIdentity } from "../../lib/x402Profile";

export function X402ProfileIdentityLinks({ identities }: { identities: X402LinkedIdentity[] }) {
  if (identities.length === 0) return null;
  return (
    <div className="mt-2 flex min-w-0 flex-wrap gap-2" aria-label="Linked public identities">
      {identities.map((identity) => (
        <Link
          key={identity.handle}
          to={`/p/${encodeURIComponent(identity.handle)}`}
          className="inline-flex min-h-8 max-w-full items-center gap-2 rounded-full border border-faint bg-paper px-2.5 py-1 text-xs text-olive-deep hover:border-olive hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-olive focus-visible:ring-offset-2"
          aria-label={`Open ${identity.handle} Boon profile`}
        >
          <span className="shrink-0" aria-hidden="true">
            {identity.provider === "github" ? <GithubMark className="h-3.5 w-3.5" /> :
              identity.provider === "x" ? <XMark className="h-3 w-3" /> : <RobotGlyph className="h-3.5 w-3.5" />}
          </span>
          <span className="min-w-0 truncate btn-mono text-[10px]">{identity.handle}</span>
          <span className="pill pill-faint shrink-0 text-[9px]">
            {identity.verification === "boon_oauth_link" ? "OAuth-linked" : "ERC-8004"}
          </span>
        </Link>
      ))}
    </div>
  );
}

function RobotGlyph({ className }: { className?: string }) {
  return <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M12 3v3M8 3h8M5 9h14v10H5z"/><circle cx="9" cy="13" r="1" fill="currentColor" stroke="none"/><circle cx="15" cy="13" r="1" fill="currentColor" stroke="none"/><path d="M9 17h6"/></svg>;
}
